import axios from 'axios';

const analyticsPath = (action = 'summary') => {
  const prefix = (window.I18n?.prefix || '').replace(/\/$/, '');
  return `${prefix ? `/${prefix}` : ''}/api/analytics/${action}`;
};

export const fetchAnalyticsSummary = ({
  password,
  startDate,
  endDate,
  regions = [],
  products = [],
  languages = [],
  producerId = '',
  detail = '',
  allProducers = false,
  allLicenses = false
}) => {
  return axios.post(analyticsPath(), {
    password,
    start_date: startDate,
    end_date: endDate,
    regions,
    products,
    languages,
    producer_id: producerId,
    detail,
    all_producers: allProducers,
    all_licenses: allLicenses
  });
};

export const exportAnalyticsCsv = ({
  password,
  startDate,
  endDate,
  regions = [],
  products = [],
  languages = [],
  producerId = ''
}) => {
  return axios.post(
    analyticsPath('export'),
    {
      password,
      start_date: startDate,
      end_date: endDate,
      regions,
      products,
      languages,
      producer_id: producerId
    },
    { responseType: 'blob' }
  );
};

export const exportAnalyticsSummaryXlsx = ({
  password,
  startDate,
  endDate,
  regions = [],
  products = [],
  languages = [],
  producerId = ''
}) => {
  return axios.post(
    analyticsPath('summary_xlsx'),
    {
      password,
      start_date: startDate,
      end_date: endDate,
      regions,
      products,
      languages,
      producer_id: producerId
    },
    { responseType: 'blob' }
  );
};
